import { Tooltip, TooltipTrigger, TooltipContent } from 'components/Display/Tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'support/helpers/currency/currency';
import { countDecimalPlaces } from 'support/helpers/numbers/numbers';

type RoundedCurrencyTooltipProps = {
  value: number;
  currency: string;
  type: string;
};

export const RoundedCurrencyTooltip = ({ value, currency, type }: RoundedCurrencyTooltipProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip>
      <TooltipTrigger>
        <div className="flex items-center gap-1 rounded-md bg-gray-50 p-1.5">
          <span className="font-bold text-gray-400">≈</span>
          <span className="font-bold text-gray-900">
            {formatCurrency(value, currency, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        {t(`webedi:documentSummary.${type}.footer.tooltip`, {
          value: formatCurrency(value, currency, {
            minimumFractionDigits: 2,
            maximumFractionDigits: countDecimalPlaces(value),
          }),
        })}
      </TooltipContent>
    </Tooltip>
  );
};
